/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Wiki_SubpagesInputs */



/**

* @param {_Wiki_SubpagesInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _wiki_subpages = /** @type {((inputs?: _Wiki_SubpagesInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Wiki_SubpagesInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Unterseiten")
});